export class DocumentoDetalleSalida {

    public id: number;
    public codigoDocumento: string;
    public codigoConsorcio: string;
    public codigoArticulo: string;
    public idLinea: number;
    public nombreArticulo: string;
    public cantidad: number;
    public lote: string;
    public dua: string;
    public contenedor: string;
    public referencia1: string;
    public referencia2: string;
    public fecha: string;
    public movInv: string;
    public factura: string;
    public listaEmpaque: string;
    public valorCIF: number;
    public impuestos: number;
    public bultos: number;
    public kilos: number;
    public comentarios: string;
    public tipoIngreso: string;
    public serie: string;

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/documento-detalle-salida.ts